import { FC, PropsWithChildren, useCallback, useEffect, useRef } from 'react';
import {
  WebsiteTileVariant,
  WeddingWebsiteTileComponent,
} from '@bridebook/web/components/wedding-website/view-mode/partials/tile-component/wedding-website-tile-component';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { useDispatch } from '@bridebook/web/lib/utils';
import { interactedWithWeddingWebsiteAnalyticsButtonClick } from '@bridebook/web/lib/wedding-website/analytics';
import { Palettes } from '@bridebook/web/lib/wedding-website/types';
import { FloatingEditButton } from '@bridebook/web/components/wedding-website/view-mode/partials/floating-edit-button/floating-edit-button';
import { useEditorSyncContext } from '@bridebook/web/components/wedding-website/main/desktop/editor-sync-context';

interface IProps extends PropsWithChildren {
  title: string;
  palette: Palettes;
  variant: WebsiteTileVariant;
  sectionName: string;
}

export const WeddingWebsiteTextField: FC<IProps> = ({
  title,
  palette,
  variant,
  children,
  sectionName,
}) => {
  const dispatch = useDispatch();
  const { registerPreviewRef, triggerDetailsSync } = useEditorSyncContext();
  const tileRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    registerPreviewRef('ourStory', tileRef.current);
  }, [registerPreviewRef]);

  const handleEditOurStory = useCallback(() => {
    triggerDetailsSync('ourStory');
    dispatch(
      interactedWithWeddingWebsiteAnalyticsButtonClick({
        section: 'ourStory',
        element: 'editButton',
      }),
    );
  }, [dispatch, triggerDetailsSync]);
  return (
    <div ref={tileRef} className="group w-full">
      <WeddingWebsiteTileComponent palette={palette} variant={variant} title={title}>
        <WeddingWebsiteTileComponent.ItemGroup>
          <WeddingWebsiteTileComponent.Text>{children}</WeddingWebsiteTileComponent.Text>
        </WeddingWebsiteTileComponent.ItemGroup>
        <FloatingEditButton
          onClick={handleEditOurStory}
          href={UrlHelper.website.weddingDetails.sectionAnchor(sectionName)}
        />
      </WeddingWebsiteTileComponent>
    </div>
  );
};
